/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-flickr': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M5 13.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zm10 0a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"/>'
  }
})
